import React from 'react';
import SelectDefault from "~/components/layout/Select";
import TextField from "~/components/layout/TextField";
import { PrimaryButton } from "../../Buttons";
import {
    Container,
    Label,
    SelectArea,
    SelectLabel,
    TextArea,
    ButtonArea,
    LoadingIcon
} from './styles';

export default function Visit(props) {
    
    return (
        <Container>
            <Label>
                Solicite uma visita comercial ao seu consultor comercial
            </Label>
            <SelectArea>
                <SelectLabel>
                    Assunto principal:
                </SelectLabel>
                <SelectDefault
                    name={props.selected}
                    setName={props.setSelected}
                    names={props.options}
                    placeholder=""
                />
            </SelectArea>
            <TextArea>
                <SelectLabel>
                    Comentários:
                </SelectLabel>
                <TextField
                    value={props.text}
                    setValue={props.setText}
                />
                <ButtonArea>
                    <PrimaryButton
                        color={ props.selected.length === 0 ? "#838aff" : null}
                        style={{ height: '30px', width: '160px', paddingTop: '2px' }}
                        onClick={() => { props.selected.length === 0 ? console.log("Loading button") : props.sendSfCase() }}
                    >
                        {props.loading ? (
                            <LoadingIcon className="fa fa-spinner fa-pulse fa-3x fa-fw" />
                        ) : (
                            "Solicitar"
                        )}
                        
                    </PrimaryButton>
                </ButtonArea>
            </TextArea>
        </Container>
    );
}
